var _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDentistCaptionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5783 19.4741H37.6367V37.299H43.5783V19.4741Z",
    fill: "#F2F3EE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5201 25.4155H31.6953V31.3571H49.5201V25.4155Z",
    fill: "#F2F3EE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8975 68.438C28.5946 68.438 28.2904 68.4219 27.9856 68.3897C24.7852 68.0523 21.9464 66.0039 20.1957 62.7695C16.6023 56.1292 13.0129 26.7368 22.2764 17.2735C26.0724 13.3952 31.691 11.0498 37.307 11L37.3574 16.9417C33.2899 16.9777 29.0838 18.7146 26.3804 21.474C23.4836 24.4305 21.9702 31.6383 22.2297 41.2499C22.4703 50.1754 24.153 57.7991 25.2751 59.8705C26.1051 61.4027 27.2789 62.3221 28.5813 62.4593C29.5668 62.5602 30.4906 62.1983 31.1147 61.459C32.2464 60.1173 32.1752 57.3428 32.1072 54.6596C32.0196 51.2362 31.9289 47.6959 34.0908 45.0885C35.6362 43.2247 37.8132 42.154 40.064 42.1507H40.074C42.2434 42.1507 44.2711 43.1508 45.7863 44.9674C48.0603 47.6963 48.1239 51.4313 48.1799 54.7268C48.2266 57.4647 48.2701 60.0503 49.4369 61.3501C50.0604 62.0439 51.0868 62.4466 52.0843 62.4052C52.7361 62.3779 53.6631 62.1471 54.3785 61.2049C56.8168 57.9934 61.0896 34.2653 53.9339 22.5598C51.7228 18.9435 46.8848 17.0575 43.2485 17.064L43.2384 11.1224H43.2674C48.5119 11.1224 55.3577 13.6836 58.8579 19.4141C66.9494 32.6638 63.256 59.2117 58.9655 64.8682C57.342 67.009 54.983 68.2497 52.3243 68.362C49.6045 68.4759 46.9319 67.3647 45.1585 65.3878C42.5055 62.4304 42.4374 58.4057 42.377 54.855C42.3361 52.4382 42.2939 49.9393 41.3657 48.8245C40.9557 48.3321 40.5326 48.0925 40.0741 48.0925H40.0722C39.5369 48.0931 38.9576 48.4077 38.5218 48.934C37.7887 49.8189 37.8523 52.3221 37.9084 54.5304C38.001 58.1637 38.1062 62.2814 35.5135 65.3591C33.8573 67.324 31.4347 68.4376 28.8975 68.438Z",
    fill: "#F2F3EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentistCaptionWhite);
export default __webpack_public_path__ + "static/media/dentist-caption-white.0e219f18ab9941666fd325b0f4716282.svg";
export { ForwardRef as ReactComponent };